/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-07-08 10:41:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\index.js
 */
/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-03-11 09:23:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import ProductRouter from './modules/product.js'
import SettledRouter from './modules/settled.js';
import AndPackage from './modules/andPackage.js';
import MoneyManagement from './modules/moneyManagement';
import Money from './modules/moneyManagement_2';
import Sales from './modules/sales';
import Financial from './modules/financial';
import shopRouter from './modules/shop';
import personalRouter from './modules/personalCenter';
import settingsRouter from './modules/settings';
import accountRouter from './modules/account';
import Contract from './modules/contract';
import Settlement from './modules/settlement';
import FundManagement from './modules/fundManagement'
import Ticket from './modules/ticket'

import orderRouter from './modules/order.js';
Vue.use(Router)

console.log('this.$route',this.$route);

const router = new Router({
  mode: 'hash',
  routes: [
    
    {
      path: '/',
      component: resolve => require(['../common/Home.vue'], resolve),
      meta: { title: '首页' },
      children: [
        {
          path: '/about',
          component: resolve => require(['../views/about/index'], resolve),
          meta: { title: '首页' }
        },
        ...SettledRouter,
        ...ProductRouter,
        ...AndPackage,
        ...MoneyManagement,
        ...Money,
        ...Sales,
        ...Financial,
        // ...MoneyManagement,
        // ...Money,
        // ...Sales,
        ...shopRouter,
        ...personalRouter,
        ...settingsRouter,
        ...orderRouter,
        ...accountRouter,
        ...Contract,
        ...Settlement,
        ...FundManagement,
        ...Ticket
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // console.log(to,'判断刷新是否进入',router.app.$options.store)
  // console.log(to,'路由为什么为null',from)
  // if (to.matched.length ===0) {                                        //如果未匹配到路由
  //   from.name ? next({ name:from.name }) : next('/');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  //   return
  // } 
  var store = router.app.$options.store;
  if(router.app.$options.store.state.shop && router.app.$options.store.state.shop.storeList && router.app.$options.store.state.shop.storeList[0] && router.app.$options.store.state.shop.storeList[0].orgType){
    // console.log(to,'判断刷新是否进入',router.app.$options.store.state.shop.storeList[0].orgType)
    next()
  }else{
    setTimeout(()=>{
      if(router.app.$options.store.state.shop && router.app.$options.store.state.shop.storeList && router.app.$options.store.state.shop.storeList[0] && router.app.$options.store.state.shop.storeList[0].orgType){
        // console.log(to,'判断刷新是否进入',router.app.$options.store.state.shop.storeList[0].orgType)
        next()
      }else{
        setTimeout(()=>{
          if(router.app.$options.store.state.shop && router.app.$options.store.state.shop.storeList && router.app.$options.store.state.shop.storeList[0] && router.app.$options.store.state.shop.storeList[0].orgType){
            // console.log(to,'判断刷新是否进入',router.app.$options.store.state.shop.storeList[0].orgType)
            next()
          }else{
            setTimeout(()=>{             
                next()                     
            },2500)
          }
         
        },1500)
      }
    },1500)
  }


  // next()
 })

 router.afterEach((to, from) => {
  console.log('页面跳转后执行')
  setTimeout(()=>{
  
      document.getElementById("main-content").scrollTop = 0 
    

  },500)
 
  })
export default router



// WEBPACK FOOTER //
// ./src/TASMini/router/index.js